/** @format */

import {
  Container,
  Stack,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
// import User from "../../dao/User";
import Approval from "../../dao/Approval";
import Waba from "../../dao/Waba";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";

// import thirdPartyLogin from "../../configs/third-party-login";
import React, { useState } from "react";
import Iconify from "../../components/Iconify";
// import { useSelector } from "react-redux";

import illustration1 from "../../assets/illustration1.png";
// import Swal from "../../reusables/CustomSwal";
// import { wabaSetStatus } from "../../store/actions";

import { timeout } from "../../utils/utilitys";
import { useSelector } from "react-redux";

export default function Marketing() {
  let auth = useSelector(({ auth }) => auth?.auth);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingFetch, setIsLoadingFetch] = useState(false);
  const [statusRegister, setStatusRegister] = useState("");
  const [wabaId, setWabaId] = useState("");
  const [fetchReload, setFetchReload] = useState(false);
  const [data, setData] = useState({});

  const handleLink = async () => {
    await setIsLoading(true);
    await timeout(1000);
    await setIsLoading(false);
    await window.open("https://onx.co.id/");
  };

  React.useEffect(() => {
    const fetchisApproval = async () => {
      await setIsLoading(true);
      await timeout(1500);
      try {
        let result = await Waba.getMyWaba();
        // console.log("MW", result);

        let formatted = await result.map((obj) => {
          return {
            label: `${obj.name} (${obj.waba_id})`,
            value: obj.waba_id,
          };
        });

        await setWabaId(formatted[0].value);
        let result2 = await Approval.getApprovalByWABAID(formatted[0].value);
        if (result2.length === 0) {
          await setStatusRegister("not register");
        } else {
          await setData(result2);
          if (result2[0]?.status === "pending") {
            await setStatusRegister("pending");
          } else if (result2[0]?.status === "approved") {
            await setStatusRegister("approved");
          } else {
            await setStatusRegister("not approved");
          }
        }
      } catch (e) {
        console.log("ERROR", e);
      }
      await setIsLoading(false);
    };
    let isFetch = true;

    if (isFetch) fetchisApproval();

    return () => {
      isFetch = false;
    };
  }, [fetchReload]);

  const handleFetchRegister = async () => {
    await setIsLoadingFetch(true);
    let body = await {
      user_id: auth?.id,
      waba_id: wabaId,
      status: "pending",
    };
    await timeout(1500);
    await Approval.postApproval(body);
    await setIsLoadingFetch(false);
    await setFetchReload(true);
  };

  return (
    <>
      {isLoading && (
        <Container
          id={"container"}
          maxWidth="sm"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              heigth: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        </Container>
      )}
      {statusRegister === "approved" && !isLoading && (
        <Container maxWidth="sm">
          <Stack>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={illustration1}
                style={{ width: "550px" }}
                alt="illustration1"
              />
            </Box>

            <Button
              size="large"
              type="submit"
              sx={{ marginTop: "10px" }}
              variant="contained"
              loading={isLoading}
              onClick={() => handleLink()}
            >
              {!isLoading ? (
                <>
                  Go to marketing application
                  <Iconify
                    icon="zondicons:link"
                    width={22}
                    height={22}
                    sx={{ marginLeft: 1 }}
                  />
                </>
              ) : (
                <>
                  <CircularProgress size="22px" sx={{ marginRight: 1 }} />
                  Loading
                </>
              )}
            </Button>
          </Stack>
        </Container>
      )}
      {statusRegister === "not register" && !isLoading && (
        <Container maxWidth="sm" height={"100%"}>
          <Stack>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={illustration1}
                style={{ width: "550px" }}
                alt="illustration1"
              />
            </Box>

            <Button
              size="large"
              type="submit"
              sx={{ marginTop: "10px" }}
              variant="contained"
              loading={isLoading}
              onClick={() => handleFetchRegister()}
            >
              {!isLoadingFetch ? (
                <>
                  Register Now
                  <Iconify
                    icon="zondicons:link"
                    width={22}
                    height={22}
                    sx={{ marginLeft: 1 }}
                  />
                </>
              ) : (
                <>
                  <CircularProgress size="22px" sx={{ marginRight: 1 }} />
                  Loading
                </>
              )}
            </Button>
          </Stack>
        </Container>
      )}

      {statusRegister === "pending" && !isLoading && (
        <Container maxWidth="sm" height={"100%"}>
          <Stack>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={illustration1}
                style={{ width: "550px" }}
                alt="illustration1"
              />
            </Box>

            <Typography variant="h4" sx={{ textAlign: "center" }}>
              Wait until you get approved
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "center" }}>
              your status is {data[0]?.status}
            </Typography>
          </Stack>
        </Container>
      )}

      {statusRegister === "not approved" && !isLoading && (
        <Container maxWidth="sm" height={"100%"}>
          <Stack>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={illustration1}
                style={{ width: "550px" }}
                alt="illustration1"
              />
            </Box>

            <Typography variant="h4" sx={{ textAlign: "center" }}>
              Wait until you get approved
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "center" }}>
              your status is {data[0]?.status}
            </Typography>
          </Stack>
        </Container>
      )}
    </>
  );
}
